// Session data meter: approximates how many bytes the app has sent/received via
// axios during THIS session (resets on every page load / login). Purely
// informational — gives the teacher peace of mind about data usage now that
// continuous polling was removed. Estimates use content-length when available,
// otherwise the serialized payload size.
let total = 0;
const listeners = new Set();

export function addBytes(n) {
  if (!n || n < 0 || Number.isNaN(n)) return;
  total += n;
  listeners.forEach((fn) => fn(total));
}

export function getBytes() {
  return total;
}

export function resetDataMeter() {
  total = 0;
  listeners.forEach((fn) => fn(total));
}

export function subscribeDataMeter(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function estimateSize(payload, headers) {
  try {
    const cl = headers && (headers['content-length'] || headers['Content-Length']);
    if (cl) {
      const n = parseInt(cl, 10);
      if (!Number.isNaN(n)) return n;
    }
  } catch (e) { /* ignore */ }
  if (payload == null) return 0;
  if (typeof payload === 'string') return payload.length;
  try {
    if (typeof Blob !== 'undefined' && payload instanceof Blob) return payload.size || 0;
    if (typeof ArrayBuffer !== 'undefined' && payload instanceof ArrayBuffer) return payload.byteLength || 0;
  } catch (e) { /* ignore */ }
  try {
    return JSON.stringify(payload).length;
  } catch (e) {
    return 0;
  }
}

export function formatBytes(bytes) {
  if (!bytes || bytes < 0) return '0 B';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}
